import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

const Footer = () => {
  const year = new Date().getFullYear();

  const socialLinks = [
    {
      href: "https://www.facebook.com/people/Plus-Distribution-Pvt-Ltd/61572249527081/",
      img: "./img/Plus-distribution-facebook.svg",
      alt: "Follow Plus Distribution on Facebook",
    },
    {
      href: "https://www.instagram.com/plusdistributionsindia",
      img: "./img/Plus-distribution-instagram.svg",
      alt: "Connect with Plus Distribution on Instagram",
    },
    {
      href: "https://wa.me/917082109652",
      img: "./img/Plus-distribution-whatsapp.svg",
      alt: "Chat with Plus Distribution on WhatsApp",
    },
  ];

  const companyLinks = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About Us" },
    { to: "/network", label: "Network" },
    { to: "/career", label: "Career" },
    { to: "/contact", label: "Contact Us" },
    
  ];

  const supportLinks = [
    { href: "https://www.unios.in/", label: "Unios", external: true },
    { to: "/infrastructure", label: "Infrastructure" },
    { to: "/franchise", label: "Franchise" },
    {
      href: "mailto:hr.workspace@plusdistributions.in",
      label: "Join Us",
      external: true,
    },
    { to: "/terms", label: "Terms & Conditions" },
  ];

  const contactLinks = [
    {
      href: "mailto:info@plusdistributions.in",
      label: "info@plusdistributions.in",
      img: "./img/plus-distribution-email.svg",
    },
    {
      href: "tel:+911244014675",
      label: "+91-124-4014675",
      img: "./img/plus-distribution-phone.svg",
    },
    {
      href: "https://www.google.com/maps/place/Plus+Distribution+Pvt.+Ltd/",
      label: "Plus Distribution Pvt. Ltd",
      img: "./img/plus-distribution-location.svg",
    },
  ];

  return (
    <footer className="bg_footer pt-md-4" role="contentinfo">
      <Container>
        <Row className="justify-content-between gap-lg-0 gap-3 border-bottom border-black py-5">
          
          <Col xl={4} lg={3} xs={12}>
            <a href="/" className="ms-auto" aria-label="Plus Distribution Home">
              <img
                loading="lazy"
                decoding="async"
                src="./img/logo.webp"
                alt="Plus Distribution Pvt. Ltd. logo"
                width={150}
                height={59}
              />
            </a>
            <p className="text-black fs_4md fw-semibold mt-2">
              Delivering Health, <br className="d-xl-block d-none" />
              Empowering Lives
            </p>
            <div className="d-flex gap-2">
              {socialLinks.map(({ href, img, alt }, idx) => (
                <a
                  key={idx}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={alt}
                >
                  <img
                    loading="lazy"
                    decoding="async"
                    src={img}
                    alt={alt}
                    width={35}
                    height={35}
                    className="social_icon transition"
                  />
                </a>
              ))}
            </div>
          </Col>

          {/* Our Company */}
          <Col lg={2} sm={3} xs={5} className="mt-2">
            <ul
              className="d-flex flex-column gap-2 mb-0 ps-0"
              aria-label="Our Company Links"
            >
              <li className="fw-semibold fs_md text-black">Our Company</li>
              {companyLinks.map(({ to, label }, idx) => (
                <li key={idx}>
                  <Link
                    to={to}
                    className="fw-normal fs_8sm text-black under_line position-relative nav_link transition"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </Col>

          {/* Support */}
          <Col
            lg={3}
            sm={3}
            xs={5}
            className="d-lg-flex justify-content-center mt-2"
          >
            <ul
              className="d-flex flex-column gap-2 mb-0 ps-0"
              aria-label="Support Links"
            >
              <li className="fw-semibold fs_md text-black">Support</li>
              {supportLinks.map(({ to, href, label, external }, idx) => (
                <li key={idx}>
                  {external ? (
                    <a
                      href={href}
                      target="_blank"
                      rel="noreferrer"
                      className="fw-normal fs_8sm text-black under_line position-relative nav_link transition"
                    >
                      {label}
                    </a>
                  ) : (
                    <Link
                      to={to}
                      className="fw-normal fs_8sm text-black under_line position-relative nav_link transition"
                    >
                      {label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </Col>

          {/* Contact Us */}
          <Col lg={3} xs={12} className="mt-2">
            <ul
              className="d-flex flex-column gap-2 mb-0 ps-0"
              aria-label="Contact Links"
              itemScope
              itemType="https://schema.org/Organization"
            >
              <li className="fw-semibold fs_md text-black">Contact Us</li>
              <meta itemProp="name" content="Plus Distribution Pvt. Ltd" />
              {contactLinks.map(({ href, label, img }, idx) => (
                <li key={idx}>
                  <a
                    href={href}
                    target="_blank"
                    rel="noreferrer"
                    className="fw-normal fs_8sm text-black mb-1 d-flex align-items-center gap-2 contact_icon nav_link transition"
                    itemProp={
                      href.startsWith("mailto:")
                        ? "email"
                        : href.startsWith("tel:")
                        ? "telephone"
                        : "url"
                    }
                  >
                    <img
                      loading="lazy"
                      decoding="async"
                      src={img}
                      alt={label}
                      width={30}
                      height={30}
                      className="transition"
                    />
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </Col>
        </Row>

        <p className="fw-normal fs_8sm text-black mb-0 py-3 text-center">
          ©
          {year} plusdistributions | All Rights Reserved
        </p>
      </Container>

     
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Plus Distribution Pvt. Ltd",
          url: "https://plusdistributions.in",
          logo: "https://plusdistributions.in/img/logo.webp",
          sameAs: socialLinks.map((s) => s.href),
          contactPoint: [
            {
              "@type": "ContactPoint",
              telephone: "+91-124-4014675",
              contactType: "customer service",
              email: "info@plusdistributions.in",
            },
          ],
        })}
      </script>
    </footer>
  );
};

export default Footer;
